/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 11:46
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class SecurityErrorLOFactory extends BasicLogObjectFactory {
    public static GENERAL_LOADER_SECURITY_ERROR: number = 1001;
    public static GENERAL_TRACKING_SECURITY_ERROR: number = 1002;

    private static SECURITY_ERROR: number = 1;

    private _operationText: string;
    private _url: string;

    constructor(subErrorId: number, operationText: string, url: string) {
        super();

        this._subErrorId = subErrorId;
        this._operationText = operationText;
        this._url = url;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, SecurityErrorLOFactory.SECURITY_ERROR.toString());
        lo.logData.set(ExternalLoggingConstants.PARAM_ERROR_EVENT_OPERATION_TEXT, this._operationText);
        lo.logData.set(ExternalLoggingConstants.PARAM_URL, this._url);

        return lo;
    }
}
